<template>
  <el-row class="xh-esg-list">
    <el-col :span="24">
      <div class="xh-esg-right-content infoArea">
        <el-row>
          <el-table
            @cell-click="showRowData"
            v-loading="loading"
            element-loading-text="数据正在加载中"
            element-loading-spinner="el-icon-loading"
            :data="tableData"
            :height="maxTableHeight"
            stripe
          >
            <template slot="empty">
              <div class="noDataTable">暂无数据</div>
            </template>
            <el-table-column
              prop="ticker"
              label="产品编码"
              width="150"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="short_name"
              label="产品名称"
              min-width="250"
              show-overflow-tooltip
              class-name="page-table-nowrap"
            >
              <template slot-scope="scope">
                <el-link :underline="false" class="page-table-link">{{
                  scope.row.short_name
                }}</el-link>
              </template>
            </el-table-column>
            <el-table-column
              prop="product_start_date"
              label="成立时间"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="product_end_date"
              label="到期时间"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="Issuer"
              label="发行机构"
              min-width="200"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="operation_type" label="产品类型" width="100">
            </el-table-column>
            <el-table-column
              prop="investment_type"
              label="投资类型"
              width="100"
            >
            </el-table-column>
            <el-table-column prop="product_status" label="产品状态" width="100">
            </el-table-column>
            <el-table-column prop="asset_size" label="净资产规模" width="100">
              <template slot-scope="{ row }">
                {{ row.asset_size | formateNumberByMillion }}
              </template>
            </el-table-column>
            <el-table-column prop="ESG_score" label="ESG评分">
            </el-table-column>
            <el-table-column prop="E_score" label="环境评分"> </el-table-column>
            <el-table-column prop="S_score" label="社会评分"> </el-table-column>
            <el-table-column prop="G_score" label="治理评分"> </el-table-column>
          </el-table>
        </el-row>
      </div>
      <div class="xh-esg-right-pagination pageArea" v-if="tableData.length">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="searchData.pageSize"
          layout="total, sizes, prev, slot, next"
          :total="searchData.pageCount"
        >
          <el-button class="page-area-number">{{
            searchData.pageNo + " / " + searchData.pageTotal
          }}</el-button>
        </el-pagination>
        <el-input-number
          v-model="searchData.pageNo"
          :max="searchData.pageTotal || 1"
          :step="1"
          :step-strictly="true"
          :controls="false"
          class="page-area-input"
          @keyup.native="checknumber($event)"
          :min="1"
        ></el-input-number>
        <el-button
          @click="handleClickEnter()"
          size="mini"
          type="primary"
          class="page-area-go"
          >GO</el-button
        >
      </div>
    </el-col>
  </el-row>
</template>

<script>
// import elPagination from "@/components/pagination";
import { mapActions } from "vuex";
export default {
  props: {},
  data() {
    return {
      searchData: {
        pageNo: 1,
        pageSize: 10,
        pageTotal: 0,
        pageCount: 0,
      },
      loading: true,
      tableData: [],
    };
  },
  components: {
    // elPagination,
  },
  mounted() {
    this.searchTableData();
  },
  methods: {
    ...mapActions("investInfo/list", {
      getFundsList: "GET_FUNDS_LIST",
    }),
    checknumber(e) {
      var keynum = window.event ? e.keyCode : e.which; //获取键盘码
      if (keynum == 189 || keynum == 190 || keynum == 109) {
        e.target.value = "";
      }
    },
    showRowData({ ticker, innercode }) {
      /* this.$utils.open("#/investInfo/detail", {
        ticker,
        innercode,
      }); */
      // this.$utils.open("#/investInfo/detail", `ticker=${ticker}&ticker=${ticker}`);
      let params = {
        path: "/investInfo/detail",
        query: {
          ticker,
          innercode,
        },
      };
      this.$router.push(params);
    },
    handleSizeChange(size) {
      this.searchData.pageSize = size;
      this.searchTableData();
    },
    handleCurrentChange(index) {
      this.searchData.pageNo = index;
      this.searchTableData();
    },
    handleClickEnter() {
      this.searchTableData();
    },
    resetSearchData() {
      this.searchData = {
        pageNo: 1,
        pageSize: 10,
        pageTotal: 0,
        pageCount: 0,
      };
    },
    searchTableData() {
      this.loading = true;
      this.getFundsList(this.searchData)
        .then((res) => {
          let { data, page } = res;
          let searchData = this.searchData;
          searchData.pageNo = page.currentPage;
          searchData.pageSize = page.pageSize;
          searchData.pageTotal = page.totalPage;
          searchData.pageCount = page.totalCount;
          this.tableData = data;
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    maxTableHeight() {
      let calHeight =
        (document.documentElement.clientHeight || document.body.clientHeight) -
        300;
      let limitHeight = 550;
      calHeight = calHeight < limitHeight ? limitHeight : calHeight;
      return calHeight;
    },
  },
};
</script>
<style lang="scss" scoped>
.xh-esg-list {
  .xh-esg-right-content {
    background-color: #ffffff;
    padding: 0 20px;
    min-height: 520px;
    /* /deep/ .el-table__body-wrapper {
      height: calc(100% - 50px);
      .el-table__body {
        height: calc(100% - 40px);
        overflow-x: hidden;
        overflow-y: auto;
      }
    } */
    .page-table-link {
      display: inline;
      white-space: nowrap;
      color: #005bac;
      font-weight: 700;
    }
    /deep/ td.page-table-nowrap{
      color: #005bac;
    }
    .noDataTable {
      color: var(--font_01);
      font-size: 16px;
      font-weight: 500;
    }
    /* /deep/
      .el-table--striped
      .el-table__body
      tr.el-table__row--striped
      td.el-table__cell {
      background-color: #f5f6fa;
    }
    /deep/
      .el-table--enable-row-hover
      .el-table__body
      tr:hover
      > td.el-table__cell {
      background-color: #edf1f5;
    } */
  }
  .xh-esg-right-pagination {
    padding: 5px 0 0 0;
    text-align: right;

    .page-area-number {
      cursor: not-allowed;
      margin-left: 5px;
      margin-right: 5px;
    }
    .page-area-input {
      width: 50px;
      margin-left: 10px;
    }
    .page-area-go {
      width: 50px;
      padding: 6px 15px;
    }
  }
}
</style>